import { useEffect, useState } from 'react';
import { listDriverDocumentTypes, type DriverDocumentType } from './drivers.api';

/**
 * The fixed document slots the office fills for a driver (licence, medical, passport) — small, admin-managed catalogue, fetched once.
 * `null` until it arrives, so the slots can show a skeleton rather than popping in; a failed load shows no slots, as before.
 */
export function useDriverDocumentTypes(): DriverDocumentType[] | null {
  const [documentTypes, setDocumentTypes] = useState<DriverDocumentType[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    listDriverDocumentTypes()
      .catch(() => [])
      .then((types) => {
        if (!cancelled) setDocumentTypes(types);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return documentTypes;
}
